import React from 'react';

import PeopleIcon from '@mui/icons-material/PeopleOutline';

import type { ICommunitiesViewCommunity } from '../../../../redux/api/communities/communities-api.types';
import AppEntityAvatar, {
  AppEntityAvatarProps,
} from '../app-entity-avatar/AppEntityAvatar';

interface AppCommunityAvatarProps extends AppEntityAvatarProps {
  community?: ICommunitiesViewCommunity;
}

export default function AppCommunityAvatar(props: AppCommunityAvatarProps) {
  const { community, ...avatarProps } = props;
  return (
    <AppEntityAvatar
      {...avatarProps}
      fallbackSeedId={community?.id}
      fallbackSeedName={community?.title}
      directPreviewStorageLink={community?.avatar?.directPreviewStorageLink}
      directStorageLink={community?.avatar?.directStorageLink}
      previewStorageLink={community?.avatar?.previewStorageLink}
      storageLink={community?.avatar?.storageLink}>
      <PeopleIcon />
    </AppEntityAvatar>
  );
}
